import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FormButtons, FormRow, LocationMapField } from '../controls';
import { ENTITY_MAP_DEFAULT_ZOOM } from '../controls/interactive-map/constants';

function buildDefaultValues(vendor) {
  return {
    description: vendor.description || '',
    vendor: vendor.vendor || {},
    vendorId: vendor.vendor?.vendorId ?? '',
  };
}

export const FestivalVendorForm = ({
  vendor,
  vendors,
  handleSave,
  handleRemove,
  onLocationChange,
  onLocationNameChange,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(vendor),
    mode: 'onSubmit',
  });

  const festivalVendorId = vendor?.vendorId;

  useEffect(() => {
    reset(buildDefaultValues(vendor));
  }, [festivalVendorId, reset]);

  const submit = (vals) => {
    const { vendorId: _id, ...rest } = vals;
    handleSave(rest);
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <FormRow label="Vendor" error={errors.vendorId?.message}>
        <Controller
          name="vendorId"
          control={control}
          rules={{ required: 'Vendor is required' }}
          render={({ field }) => (
            <select
              className="h-10 w-full rounded-[20px] border border-[var(--input)] px-4 outline-none"
              value={field.value === '' ? '' : String(field.value)}
              onChange={(e) => {
                const id = e.target.value;
                if (!id) {
                  field.onChange('');
                  setValue('vendor', {});
                  return;
                }
                const found = vendors.find(
                  (x) => String(x.vendorId) === String(id),
                );
                field.onChange(found?.vendorId ?? '');
                setValue('vendor', found || {});
              }}
            >
              <option value="">Select a vendor</option>
              {vendors.map((v) => (
                <option key={v.vendorId} value={String(v.vendorId)}>
                  {v.vendorName}
                </option>
              ))}
            </select>
          )}
        />
      </FormRow>
      <FormRow label="Description">
        <textarea
          placeholder="Festival Specific Vendor Description..."
          {...register('description')}
        />
      </FormRow>
      <FormRow>
        <LocationMapField
          key={vendor?.vendorId}
          shouldPromptForMap
          defaultZoom={ENTITY_MAP_DEFAULT_ZOOM}
          location={vendor.location}
          locationName={vendor.location?.locationName}
          onLocationChange={onLocationChange}
          onLocationNameChange={onLocationNameChange}
        />
      </FormRow>
      <FormButtons
        showDelete={vendor.vendorId}
        title="Vendor"
        onDelete={handleRemove}
      />
    </form>
  );
};
